
import React from 'react';

function BurnabyMarket() {
  const stats = [
    { value: '$145', label: 'Average Nightly Rate', trend: '+12% YoY' },
    { value: '72%', label: 'Average Occupancy', trend: '+5% YoY' },
    { value: '850+', label: 'Active STR Listings', trend: 'Growing Market' },
    { value: '$38K', label: 'Avg Annual Revenue', trend: 'Top Performers' }
  ];

  const attractions = [
    { name: 'Metropolis at Metrotown', type: 'Shopping', distance: 'Central Burnaby' },
    { name: 'Burnaby Mountain', type: 'Nature', distance: 'North Burnaby' },
    { name: 'Central Park', type: 'Recreation', distance: 'Central Burnaby' },
    { name: 'SFU Campus', type: 'Education', distance: 'Burnaby Mountain' },
    { name: 'Deer Lake Park', type: 'Nature', distance: 'South Burnaby' },
    { name: 'Brentwood Town Centre', type: 'Shopping', distance: 'North Burnaby' }
  ];

  return (
    <section className="py-24 lg:py-32 bg-[#F8F8F8]">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            Market Insights
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Burnaby STR Market Performance
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            As Metro Vancouver's third-largest city, Burnaby offers strong STR potential with proximity to Vancouver, excellent transit, and diverse attractions.
          </p>
        </div>

        <div className="grid md:grid-cols-4 gap-6 mb-16">
          {stats.map((stat, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl p-8 text-center shadow-sm hover:shadow-lg transition-all"
            >
              <div className="text-4xl font-bold text-[#882629] mb-2">{stat.value}</div>
              <p className="text-[#505A5A] font-medium mb-1">{stat.label}</p>
              <span className="text-sm text-green-600 font-medium">{stat.trend}</span>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          <div>
            <h3 className="text-2xl font-semibold text-[#505A5A] mb-6">
              Key Demand Drivers
            </h3>
            <div className="grid grid-cols-2 gap-4">
              {attractions.map((attraction, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl p-4 shadow-sm"
                >
                  <h4 className="font-medium text-[#505A5A] mb-1">{attraction.name}</h4>
                  <div className="flex items-center gap-2 text-sm text-[#505A5A]/60">
                    <span className="bg-[#882629]/10 text-[#882629] px-2 py-0.5 rounded text-xs">
                      {attraction.type}
                    </span>
                    <span>{attraction.distance}</span>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="bg-white rounded-2xl p-8 shadow-sm">
            <h3 className="text-2xl font-semibold text-[#505A5A] mb-6">
              Why Burnaby for STR?
            </h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-xl text-[#882629] mt-0.5"></i>
                <div>
                  <span className="font-medium text-[#505A5A]">SkyTrain Connectivity</span>
                  <p className="text-sm text-[#505A5A]/60">Multiple stations provide easy access to Vancouver and beyond</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-xl text-[#882629] mt-0.5"></i>
                <div>
                  <span className="font-medium text-[#505A5A]">Lower Entry Costs</span>
                  <p className="text-sm text-[#505A5A]/60">More affordable than Vancouver with similar demand potential</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-xl text-[#882629] mt-0.5"></i>
                <div>
                  <span className="font-medium text-[#505A5A]">Business Travel</span>
                  <p className="text-sm text-[#505A5A]/60">Corporate headquarters and tech companies drive weekday demand</p>
                </div>
              </li>
              <li className="flex items-start gap-3">
                <i className="ri-checkbox-circle-fill text-xl text-[#882629] mt-0.5"></i>
                <div>
                  <span className="font-medium text-[#505A5A]">University Visitors</span>
                  <p className="text-sm text-[#505A5A]/60">SFU and BCIT bring consistent visitor traffic year-round</p>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}

export default BurnabyMarket;
